import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";

const Lightbulb = ({ location }) => {
    const [page, setPage] = useState("");  // Store HTML as a string

    useEffect(() => {
        fetch("https://seemly-plump-recorder.glitch.me")
            .then(response => response.text())
            .then(html => {
                // Parse the text
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                // Extract the body content as a string
                setPage(doc.body.innerHTML);
            })
            .catch(error => {
                console.error("Failed to fetch page: ", error);
            });
    }, []); // Runs only once when the component mounts

    return (
        <Fragment>
            <div className="container" dangerouslySetInnerHTML={{ __html: page }} />
        </Fragment>
    );
};

Lightbulb.propTypes = {
    location: PropTypes.object
};

export default Lightbulb;
